import {decorate, observable} from "mobx";
import {Modulator} from "./Modulator";
import {PresetType} from "./PresetsStore";
import {WAVEFORM_SIN_NAME} from "../waveforms";

class ModulatorsStore {

    running = false;
    paused = false;
    modulators: Modulator[];
    syncRequested = false;

    requestRef : any = null;
    previousTimeRef : any = null;

    autoStart = true;

    constructor() {
        this.modulators = [];
        this.modulators.push(new Modulator({
            name: "",
            fName: WAVEFORM_SIN_NAME,
            freq: 1 / 2,
            phase: 0,
            messageType: "CC",
            messageNumber: 3,
            channel: 0,
            range: 127,
            min: 0,
            max: 127,
            linked: false,
            customValues: "",
            customOrder: null
        }));

        if (this.autoStart) this.requestRef = requestAnimationFrame(this.animate);
    }

    // send = (value: number) => {
    //     // console.log("send", value);
    //     midi.sendCC(3, value, 1);
    // }
    loadPreset(preset: PresetType) {
        // console.log("loadPreset", preset);
        this.stop();
        this.modulators = [];
        preset.modulators.forEach(
            (modulator, index) => {
                this.modulators.push(new Modulator(modulator));
            }
        );
    }

    animate = (time: number) => {
        // console.log("animate");
        if (this.previousTimeRef !== undefined) {
            // const deltaTime = time - this.previousTimeRef;

            // if (this.syncRequested)

            this.modulators.forEach(
                m => {
                    m.tick(time);
                }
            );
        }
        this.previousTimeRef = time;
        this.requestRef = requestAnimationFrame(this.animate);
    }

    play = () => {
        // if (this.running) return;

        this.modulators.forEach((m, i) => {
            m.play();
        })

        this.requestRef = requestAnimationFrame(this.animate);

        this.paused = false;
        this.running = true;    // this is used with the SPACE keyboard shortcut
    }

    pause = () => {
        // if (!this.running) return;
        // cancelAnimationFrame(this.requestRef);

        this.modulators.forEach((m, i) => {
            m.pause();
        })

        this.running = false;   // this is used with the SPACE keyboard shortcut
        this.paused = true;
    }

    stop = () => {
        // if (!this.running) return;
        // cancelAnimationFrame(this.requestRef);

        this.modulators.forEach((m, i) => {
            m.stop();
        })

        this.paused = false;
        this.running = false;
    }

    mute = () => {
        this.modulators.forEach((m, i) => {
            m.mute();
        })
    }

    unmute = () => {
        this.modulators.forEach((m, i) => {
            m.unmute();
        })
    }

    /**
     * Sync all modulators; set X value the same
     */
    sync = () => {
        this.syncRequested = true;

        //FIXME: implement a better sync mechanism

        this.modulators.forEach((m, i) => {
            m.stop();
        })
        this.modulators.forEach((m, i) => {
            m.play();
        })
    }

    addModulator = () => {
        this.modulators.push(new Modulator({
            name: "",
            fName: "sin",
            freq: 1/2,
            phase: 0,
            messageType: "CC",
            messageNumber: 3,
            channel: 0,
            range: 127,
            min: 0,
            max: 127,
            linked: false,
            customValues: "",
            customOrder: null
        }));
    }

    deleteModulator = (index: number) => {
        this.modulators.splice(index, 1);
    }

    linkModulator = (index: number) => {
        // console.log("linkModulator", index);
        // is there an already linked modulator?:
        const master = this.modulators.find(m => m.linked);
        this.modulators[index].linked = true;
        // console.log("linkModulator linked", this.modulators[index].linked);
        if (master) {
            this.modulators[index].linkTo(master);
        }
    }

    unlinkModulator = (index: number) => {
        this.modulators[index].unlink();
    }

    setFreq = (freq: number, index: number) => {
        // console.log("setFreq");
        this.modulators[index].setFreq(freq);
        if (this.modulators[index].linked) {
            // console.log("setFreq master", index);
            this.modulators.forEach((modulator, i) => {
                if ((index !== i) && modulator.linked) {
                    // console.log("setFreq linked", i);
                    modulator.setFreq(freq);
                }
            })
        }
    }

}

decorate(ModulatorsStore, {
    running: observable,
    paused: observable,
    modulators: observable
});

export default new ModulatorsStore();
